export namespace Accessibility {
  export const DefaultRightClickModifierKey = 'a';

  export namespace Plugin {
    export const Name = 'accessibility';
  }
}
